import React from 'react'
import { Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/** Wallbox card step component */
export const WallboxCardStep: React.FC = () => {
  const { t } = useCustomTranslation()
  return <Typography>{t('emobility.tour.wallbox-card')}</Typography>
}
